export default "__VITE_ASSET__CNhkYwuY__"